'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPaperclip = function FaPaperclip(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 30.9q0 2.6-1.7 4.4t-4.4 1.8q-3 0-5.2-2.3l-17.4-17.3q-2.5-2.6-2.5-6.1 0-3.5 2.4-6t6-2.5q3.6 0 6.1 2.6l13.5 13.5q0.3 0.2 0.3 0.5 0 0.3-0.7 1t-1.1 0.7q-0.2 0-0.5-0.2l-13.5-13.6q-1.8-1.7-4-1.7-2.4 0-4 1.7t-1.7 4q0 2.4 1.7 4.1l17.4 17.3q1.4 1.4 3.2 1.4 1.4 0 2.4-0.9t0.9-2.4q0-1.8-1.4-3.2l-13-13q-0.6-0.5-1.3-0.5-0.7 0-1.1 0.4t-0.4 1.1q0 0.7 0.6 1.3l9.1 9.1q0.2 0.3 0.2 0.5 0 0.4-0.7 1.1t-1 0.7q-0.3 0-0.5-0.3l-9.2-9.1q-1.4-1.4-1.4-3.3 0-1.9 1.3-3.1t3.1-1.3q2 0 3.3 1.4l13 13q2.2 2.2 2.2 5.2z' })
        )
    );
};

exports.default = FaPaperclip;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-icons/lib/fa/paperclip.js
 ** module id = 1760
 ** module chunks = 0
 **/